import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'phoneNumber',
  standalone: true,
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string | null): string | undefined {
    if (value === undefined || value == null) {
      return undefined;
    }

    const area = value.substring(0, 3);
    const first = value.substring(3, 6);
    const second = value.substring(6);


    const length = value.length || 0;
    let ret = '';
    if (length > 0 && length <= 3) {
      ret = `(${area}`;
    } else if (length > 3 && length <= 6) {
      ret = `(${area}) ${first}`;
    } else if (length > 6) {
      ret = `(${area}) ${first}-${second}`;
    }


    return length !== 0 ? ret : undefined;
  }
}
